import { useState } from 'react'
import BigNumber from 'bignumber.js'
import lockV2Abi from 'config/abi/candyLockV2.json'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { useSlowRefreshEffect } from 'hooks/useRefreshEffect'
import { getCandyLockV2Address } from 'utils/addressHelpers'
import { BIG_ZERO } from 'utils/bigNumber'
import { publicClient } from 'utils/wagmi'

// Retrieve reward from lock
const useLockReward = (lockId) => {
  const { chainId } = useActiveWeb3React()
  const [ deps, setDeps ] = useState(false)
  const [value, setValue] = useState({
    reward: BIG_ZERO,
    penaltyPercent: 0,
    penaltyAppliedReward: BIG_ZERO
  })
  const candyLockV2Address = getCandyLockV2Address(chainId)

  useSlowRefreshEffect(() => {
    const fetchLockReward = async () => {
      const client = publicClient({ chainId })

      const rewardResult = await client.readContract({
        abi: lockV2Abi,
        address: candyLockV2Address,
        functionName: 'pendingReward',
        args: [lockId]
      })
      const reward = new BigNumber(rewardResult[0].toString())
      const penaltyPercent = Number(rewardResult[1].toString())
      const penaltyAppliedReward = new BigNumber(rewardResult[2].toString())

      setValue({
        reward,
        penaltyPercent,
        penaltyAppliedReward
      })
    }

    fetchLockReward()
  }, [candyLockV2Address, chainId, lockId, deps])

  const fetchUpdates = () => {
    setDeps(!deps)
  }

  return { ...value, fetchUpdates }
}

export default useLockReward
